import { render, staticRenderFns } from "./studylevel.vue?vue&type=template&id=7a99095a&"
import script from "./studylevel.vue?vue&type=script&lang=js&"
export * from "./studylevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports